const _invoiceNumber = Symbol();
const _invoiceDateTime = Symbol();
const _invoiceAmount = Symbol();
const _transportName = Symbol();
const _truckNumber = Symbol();
const _document = Symbol();
const _truckDriverPhone = Symbol();
const _receiveDateTime = Symbol();
const _invoiceId = Symbol();
const _comment = Symbol();
const _errs = Symbol();
class Invoice {
    constructor({ invoiceId, invoiceNumber, invoiceDateTime, invoiceAmount, transportName, truckNumber, comment, document, truckDriverPhone, receiveDateTime }) {

        this[_errs] = {};
        Object.defineProperties(this, {
            invoiceId: {
                enumerable: true,
                configurable: true,
                set: function (value = null) {
                    this[_invoiceId] = value;
                },
                get: function () {
                    return this[_invoiceId];
                }
            },
            invoiceNumber: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_invoiceNumber] = value.toUpperCase();
                        delete this[_errs].invoiceNumber;
                    } else {
                        this[_errs].invoiceNumber = "Invoice number within 2 to 45 characters";
                    }
                },
                get: function () {
                    return this[_invoiceNumber];
                }
            },
            invoiceDateTime: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (value) {
                        let dateTime = value.split("T");
                        const datePattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                        const timePatterm = /^([0-9]{2}):([0-9]{2})$/;
                        if (datePattern.test(dateTime[0]) && timePatterm.test(dateTime[1]) && Date.parse(value)) {
                            this[_invoiceDateTime] = value;
                            delete this[_errs].invoiceDateTime;

                        } else {
                            this[_errs].invoiceDateTime = "please enter a valid invoice date";
                        }
                    } else {
                        this[_errs].invoiceDateTime = "please enter a valid invoice date";
                    }
                },
                get: function () {
                    return this[_invoiceDateTime];
                }
            },
            receiveDateTime: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (value) {
                        const dateTime = value.split("T");
                        const datePattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                        const timePatterm = /^([0-9]{2}):([0-9]{2})$/;
                        if (datePattern.test(dateTime[0]) && timePatterm.test(dateTime[1]) && Date.parse(value)) {

                            if (this.invoiceDateTime) {
                                if (new Date(this.invoiceDateTime) <= new Date(value)) {
                                    this[_receiveDateTime] = value;
                                    //this._receiveDateTime = new Date(value);
                                    delete this[_errs].receiveDateTime;
                                } else {
                                    this[_errs].receiveDateTime = "Receive date canot be less than Invoice date";
                                }
                            } else {
                                //delete this._errs.receiveDateTime;
                                this[_errs].receiveDateTime = "Enter invoice date first";
                            }

                        } else {
                            this[_errs].receiveDateTime = "please enter a valid receive date";
                        }
                    } else {
                        this[_errs].receiveDateTime = "please enter a valid receive date";
                    }
                },
                get: function () {
                    return this[_receiveDateTime];
                }
            },

            invoiceAmount: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x) {
                        this[_invoiceAmount] = x;
                        delete this[_errs].invoiceAmount;
                    } else {
                        this[_errs].invoiceAmount = "invoiceAmount must be a valid number";
                    }
                },
                get: function () {
                    return this[_invoiceAmount];
                }
            },
            truckNumber: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_truckNumber] = value.toUpperCase();
                        delete this[_errs].truckNumber;
                    } else {
                        this[_errs].truckNumber = "Lorry number must be 2 to 45 characters";
                    }
                },
                get: function () {
                    return this[_truckNumber];
                }
            },
            transportName: {
                enumerable: true,
                configurable: true,
                set: function (value = "") {
                    this[_transportName] = value.toUpperCase();
                },
                get: function () {
                    return this[_transportName];
                }
            },
            comment: {
                enumerable: true,
                configurable: true,
                set: function (value = "") {
                    this[_comment] = value;
                },
                get: function () {
                    return this[_comment];
                }
            },
            document: {
                enumerable: true,
                configurable: true,
                set: function (value = "") {
                    this[_document] = value;
                },
                get: function () {
                    return this[_document];
                }

            },
            truckDriverPhone: {
                enumerable: true,
                configurable: true,
                set: function (value = "") {
                    this[_truckDriverPhone] = value;
                },
                get: function () {
                    return this[_truckDriverPhone];
                }
            }
        });

        this.invoiceId = invoiceId;
        this.invoiceNumber = invoiceNumber;
        this.invoiceDateTime = invoiceDateTime;
        this.invoiceAmount = invoiceAmount;
        this.transportName = transportName;
        this.truckNumber = truckNumber;
        this.comment = comment;
        this.document = document;
        this.truckDriverPhone = truckDriverPhone;
        this.receiveDateTime = receiveDateTime;
    }

    hasError() {
        return Object.keys(this[_errs]).length > 0 ? true : false;
    }

    getErrors() {
        return this[_errs];
    }


}

module.exports = Invoice;


// WEBPACK FOOTER //
// ./src/models/invoice.js